<template>
  <div class="page-container">
    <Hero title="Celebrate with us" imageUrl="Nicole+Jon-71.jpg" altText="Engagement photo courtesy of Henry Cotton"/>
    <div class="card">
      <section>
        <h3 class="header">When</h3>
        <p class="info">July 23, 2022</p>
      </section>
      <section>
        <h3 class="header">Where</h3>
        <p class="info">Lake Pearl <br> Wrentham, MA</p>
      </section>
      <section>
        <h3 class="header">Ceremony</h3>
        <p class="info">Beach <br> 4:30PM</p>
      </section>
      <section>
        <h3 class="header">Cocktail Hour</h3>
        <p class="info">Boat House <br> 5:00 PM</p>
      </section>
      <section>
        <h3 class="header">Reception</h3>
        <p class="info">Tent <br> 6:00 - 10:00 PM</p>
      </section>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from '@/components/Hero.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'WeddingDay',
  components: {
    Hero,
    Footer
  }
}
</script>

<style scoped lang="scss">
  .card {
    width: 100%;
    max-width: 600px;
    margin: 80px auto;
    border: 2px solid #988ABD;
    background-color: #FFF;
    padding: 40px 20px 20px;
    text-align: center;
    color: #323842;
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.3);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.3);
    box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.3);

    section {
      margin-bottom: 40px;

      .header {
        text-transform: uppercase;
        font-size: 1.125rem;
        margin: 0;
        letter-spacing: 0.15rem;

        .embelish {
          color: #988ABD;
          padding: 0 12px;
        }
      }

      .info {
        font-size: 1rem;
        margin: 0.75rem 0 0 0;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .card {
      margin: 40px 20px;
    }
  }
</style>
